import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import useWindowSize from "../hooks/useWindowSize";

export default function InnovativeApproach() {
  const targetRef = useRef(null);
  let width = useWindowSize();
  const isDesktop = width >= 768;
  const { scrollYProgress } = useScroll(
    isDesktop
      ? {
          target: targetRef,
          offset: ["start start", "end end"],
        }
      : undefined
  );

  const y = useTransform(
    scrollYProgress,
    [0, 1],
    ["70%", "-80%"]
    // [`${width < 768 ? "10%" : "70%"}`, `${width < 768 ? "-40%" : "-20%"}`]
  ); // de 0 a -220px

  const items = [
    {
      title: "Simplicity",
      description:
        "We reduce systemic risk from day one by focusing on the critical path, eliminating inefficiencies, and enforcing uncompromising quality standards. The result: projects that stay disciplined, waste less, and deliver durable value.",
      },
    {
      title: "Communication",
      description:
        "Transparent, disciplined updates keep every stakeholder aligned and accountable. By turning complexity into clarity, we enable faster decisions and reduce costly uncertainty.",
    },
    {
      title: "Dedication",
      description:
        "We treat every project as our own, protecting budgets, respecting timelines, and standing by our partners through every challenge. Our commitment goes beyond contracts, focusing on trust, collaboration, and creating places people are proud to call home.",
    },
  ];
  return (
    <section className="bg-primario text-secundario p-5 md:px-5 font-secundaria w-full">
      {width > 768 ? (
        <div ref={targetRef} className="relative h-[200vh]" aria-hidden={false}>
          <div className="sticky top-0 min-h-screen flex flex-row justify-center items-center overflow-hidden gap-5 lg:gap-10 xl:gap-20">
            {/* Título */}
            <h2 className="md:w-1/2 lg:w-1/2 text-3xl sm:text-4xl md:text-5xl md:text-center  xl:text-6xl 2xl:text-7xl font-bold lg:text-right font-primaria ">
              Our Innovative Approach
            </h2>

            <motion.div
              style={{ y }}
              className="md:w-1/2 lg:w-1/2 xl:w-1/2 h-screen"
            >
              {items.map((items, i) => (
                <div key={i} className="h-[30vh] md:h-[56vh] lg:h-[60vh]">
                  <h3 className="text-2xl md:text-2xl xl:text-4xl 2xl:text-5xl font-semibold mb-4 font-primaria">
                    {items.title}
                  </h3>
                  <p className="text-lg md:text-xl 2xl:text-2xl text-white leading-relaxed">
                    {items.description}
                  </p>
                </div>
              ))}
            </motion.div>
          </div>
        </div>
      ) : (
        <div ref={targetRef} className="relative flex flex-col gap-5">
          <h2 className=" text-4xl sm:text-5xl font-primaria font-bold ">Our Innovative Approach</h2>
          <div className="flex flex-col gap-10 ">
          {items.map((item, i) => (

            <div key={i} className="h-[40vh] sm:h-[40vh] sticky top-20 flex flex-col justify-center  bg-white text-primario rounded-xl p-5 gap-2">
              <h3 className="text-3xl sm:text-4xl font-primaria font-bold ">{item.title}</h3>
              <p className="text-lg sm:text-xl">{item.description}</p>
            </div>
          ))}

          </div>
        </div>
      )}
    </section>
  );
}
